import React from 'react';
import { Dialog, Slide, SlideProps } from '@mui/material';
import { useAlert, NavigationBackButton, ProviderDialogNavigation } from '@uplift/ui-v2';
import { MatchingProfileData, MatchingProvidersType, PsychAppointmentBookingSource } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { PsychiatryMatching } from '../../../../../components';

const Transition = React.forwardRef((
  props: SlideProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

export type MatchingFlowContainerProps = {
  open: boolean;
  onClose: (complete: boolean) => void;
  patientName: string;
  patientId: string;
  stateId: string;
  providers?: MatchingProfileData[];
  matchingProvidersType?: MatchingProvidersType;
};

export const MatchingFlowContainer: React.VFC<MatchingFlowContainerProps> = props => {
  const l10n = useL10n();
  const alert = useAlert();

  const handleClose = () => {
    props.onClose(false);
  };

  const handleDone = (complete: boolean) => {
    props.onClose(complete);
    if (complete) {
      alert.success(`We sent ${props.patientName} a confirmation email`, {
        title: 'Consultation scheduled',
      });
    }
  };

  return (
    <Dialog fullScreen open={props.open} onClose={handleClose} TransitionComponent={Transition}>
      <ProviderDialogNavigation
        position="sticky"
        title={l10n.clientProfile.sections.psychiatry}
        leftActions={
          <NavigationBackButton onClick={handleClose}>Back to Chart</NavigationBackButton>
        }
      />
      <PsychiatryMatching
        stateId={props.stateId}
        patientName={props.patientName}
        patientId={props.patientId}
        providers={props.providers}
        onDone={handleDone}
        source={PsychAppointmentBookingSource.providerClientMedicalRecord}
        matchingProvidersType={props.matchingProvidersType}
      />
    </Dialog>
  );
};
